module.exports = __webpack_public_path__ + "static/media/stars1.b0d011fc.jpg";